import React, { useState } from "react";
import Label from "../../Label";
import { ApprovedSign, DownArrowIcon } from "../../Icons";
import LoadingSpinner from "../../Icons/LoadingSpinner";

const CryptoNetworksDropdown = ({
  networks,
  value,
  onChange,
  label,
  id,
  placeholder,
  error,
  loading,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleSelect = (network) => {
    onChange(network);
    setIsOpen(false);
  };

  const getValue = () => {
    if (loading) {
      return (
        <span className="flex">
          <LoadingSpinner /> loading...
        </span>
      );
    } else if (error) {
      return error;
    } else if (!value) {
      return placeholder;
    } else {
      return value;
    }
  };

  return (
    <div className="relative dropdown-wrapper">
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={`dropdown-control
          ${
            error
              ? "border-error-500 focus-within:border-error-500 text-error-500 bg-error-500/10"
              : "focus-within:border-primary-600 text-text-primary bg-body-"
          }
          `}
      >
        <Label
          htmlFor={id}
          className="dropdown-label"
          text={label}
        />
        <div className="flex justify-between items-center">
          <span
            className={`dropdown-value ${
              value ? "dropdown-value-selected" : "dropdown-value-placeholder"
            }`}
          >
            {getValue()}
          </span>
          <div className="absolute inset-y-0 right-3 flex items-center">
            <DownArrowIcon className="h-5 w-5" />
          </div>
        </div>
      </div>

      <div
        className={`dropdown-menu-wrapper
          ${
            isOpen
              ? "opacity-100 scale-100 pointer-events-auto"
              : "opacity-0 scale-95 pointer-events-none"
          }
        `}
        style={{ left: 0 }}
      >
        {isOpen && (
          <ul className="dropdown-menu">
            {networks.map((network) => (
              <li
                key={network}
                className={`
                ${
                  network === value
                    ? "dropdown-item-selected"
                    : "dropdown-item-hover"
                }
                dropdown-item`}
                onClick={() => handleSelect(network)}
              >
                <span>{network}</span>
                {network === value && <ApprovedSign />}
              </li>
            ))}
          </ul>
        )}
        {error && <span className="text-error-500 text-sm">{error}</span>}
      </div>
    </div>
  );
};

export default CryptoNetworksDropdown;
